import React from 'react';

export const CleanlinessRightImage = () => {
  return (
    <div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/cleanliness/cleanliness-right.jpeg")`}}></div>
  );
};